import "whatwg-fetch";
import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";
import type { BannersAdapter } from "../types";

const sypiBannersAdapter: BannersAdapter = {
  fetchAllBanners: async (fetchConfig?: Record<string, any>) => {
    let route = `/banners${
      fetchConfig ? `${convertQueryObjToString(fetchConfig, true)}` : ""
    }`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchIndividualBanner: async (bannerId: string | number, ctid?: string) => {
    const route = `${ctid ? "/" + ctid : ""}/banners/id/${bannerId}`;
    const apiConfig = getAPIConfig(route, !ctid, !!ctid);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchPositions: async () => {
    let route = `/banners/config`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  postNewBanner: async (changes: Record<string, any>) => {
    const apiConfig = getAPIConfig("/banners");
    const response = await executeAPIRequest(apiConfig, "POST", {}, changes);
    try {
      const responseData = await response.json();
      return handleAPIResponse(responseData);
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(response);
    }
  },

  patchBanner: async (bannerId: string | number, changes: Record<string, any>) => {
    const apiConfig = getAPIConfig(`/banners/id/${bannerId}`);
    const response = await executeAPIRequest(apiConfig, "PATCH", {}, changes);
    try {
      const responseData = await response.json();
      return handleAPIResponse(responseData);
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(response);
    }
  },

  importAllBanners: async (ctid: string) => {
    const route = `/banners/live?import_ctid=${ctid}`;
    const apiConfig = getAPIConfig(route);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.sypiBannersAdapter = sypiBannersAdapter;

export default sypiBannersAdapter;
export type { BannersAdapter };
